/* istanbul ignore file */

/* tslint:disable */

/* eslint-disable */
export var jove__app__quote__model__BusinessType;

(function (jove__app__quote__model__BusinessType) {
  jove__app__quote__model__BusinessType["BT_001"] = "BT-001";
  jove__app__quote__model__BusinessType["BT_002"] = "BT-002";
  jove__app__quote__model__BusinessType["BT_002_2"] = "BT-002-2";
  jove__app__quote__model__BusinessType["BT_003"] = "BT-003";
  jove__app__quote__model__BusinessType["BT_004"] = "BT-004";
  jove__app__quote__model__BusinessType["BT_005"] = "BT-005";
  jove__app__quote__model__BusinessType["BT_006"] = "BT-006";
  jove__app__quote__model__BusinessType["BT_007"] = "BT-007";
  jove__app__quote__model__BusinessType["BT_008"] = "BT-008";
})(jove__app__quote__model__BusinessType || (jove__app__quote__model__BusinessType = {}));